import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { object, func, array, bool } from 'prop-types';
import { isURL } from 'validator';
import {
  startSetStreamSettings,
  resetStream,
  startSetStreamOffer,
  startSetStreamLandingFeaturesSettings,
} from '../../../actions/streams';
import { startSetMyOffers, startSetEditProfile, startSetProfile } from '../../../actions/webmaster';
import { agencies, domains, streams, statistics } from '../../../services/ApiService';
import { animatedScrollTo, setDeep } from '../../../utils/utils';
import { FMessage, iFMessage } from '../../../hoc/IntlComponents';
import { parse } from 'query-string';
import { setRedirectToAgenciesData } from '../../../actions/agencies';
import moment from 'moment';
import { FlowFormView } from '../index';
import { startSetDomainReplicaOffersIds } from '../../../actions/domains';

/**
 * Create/Update Flow Form
 *
 * @class FlowForm
 * @extends {Component}
 * @return {JSX.Element} JSX.element
 */
class FlowForm extends Component {
  static propTypes = {
    onSubmit: func.isRequired,
    stream: object,
    offers: array,
    loading: bool,
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    loading: true,
    offers: [],
    offer: {},
    settings: {},
  };

  constructor(props) {
    super(props);
    const isClick = get(props, 'history.location.state.click');
    let title = props.stream ? props.stream.title : '';

    this.state = {
      stream: {
        editable: true,
        agency: null,
        abTest: props.stream ? props.stream.abTest : true,
        id: props.stream ? props.stream.id : undefined,
        title,
        rotator_domain: props.stream ? props.stream.rotator_domain : '',
        failAction: { type: null, value: null },
        offerId: props.stream ? props.stream.offerId : props.selectedOffer,
        landingsId: props.stream
          ? props.stream.landingsId
          : props.selectedLanding
          ? [props.selectedLanding]
          : [0],
        transitsId: props.stream
          ? props.stream.transitsId
          : props.selectedPreLanding
          ? [props.selectedPreLanding]
          : [],
        features: props.stream ? props.stream.features : [],
        transitFeatures: props.stream ? props.stream.transitFeatures : {},
        pixels: props.stream ? props.stream.pixels : [],
        statuses: props.stream ? props.stream.statuses : [2],
        postback: props.stream ? props.stream.postback : { method: 0, url: '' },
        trackers: props.stream ? props.stream.trackers : {},
        transit_comebacker: props.stream ? props.stream.transit_comebacker : 0,
        direct_link_without_redirect: props.stream
          ? this.getDirectLinkSubdomain(props.stream.directLinkLandingWithoutRedirect)
          : '',
        isTikTok:
          props.stream &&
          props.stream.settings?.landings &&
          props.stream.settings.landings['34']?.e === '1'
            ? true
            : false,
      },
      domainParking: {
        enabled: false,
        domainName: '',
      },
      iframeConstructorModalOpen: false,
      subAccount: '',
      deepLink: '',
      errors: {},
      isClick,
      type: isClick ? 'click' : '',
      modal: false,
      message: '',
      use_transit_service: props.profile.use_transit_service,
      trackersDropdownOpen: false,
      isExtraSettingsOpen: false,
      redirectedFromOffer: null,
      isPrelandersCollapseOpen: false,
      isUsingDirectLinkWithoutRedirectLanding: props.stream
        ? !!props.stream.directLinkLandingWithoutRedirect
        : false,
      hasActiveVkCabinets: false,
      showVkCabinetSubtext: false,
      showWarning: false,
      showDirectLinkTour: false,
      alreadyShowedDirectLinkTour: false,
      currentLandingSettings: {},
      currentIFrameSettings: {},
      iframeConstructorLoading: true,
      currentLandingSettingsOverrides: {},
    };

    this._alertRefs = {
      title: createRef(),
      offers: createRef(),
      landings: createRef(),
      rotator_domain: createRef(),
      directLinkLanding: createRef(),
    };
  }

  componentDidMount() {
    const { offer } = parse(window.location.search);

    if (offer) {
      this.props
        .startSetStreamOffer(parse(window.location.search).offer)
        .then((data) => this.setState({ redirectedFromOffer: data.offer }));
    }

    this.props.startSetMyOffers({ short: 1 }).then(() => {
      if (this.state.isClick) {
        this.props.startSetDomainReplicaOffersIds();
      }

      const { stream } = this.state;

      if (!stream.id && stream.offerId > 0) {
        this.handleOfferChange({ value: stream.offerId }, true);
      }

      this.props.startSetStreamSettings().then(() => {
        const { settings, intl } = this.props;

        if (
          stream &&
          !stream.id &&
          !stream.title &&
          settings.base &&
          settings.base.nextFlowIndex >= 0
        ) {
          this.setState(({ stream }) => ({
            stream: {
              ...stream,
              title: `${intl.formatMessage({
                id: 'flow.form.title.placeholder',
                defaultMessage: 'Flow',
              })} ${settings.base.nextFlowIndex}`,
            },
          }));
        }
      });

      agencies
        .getCabinets(2)
        .then((resp) => resp.items.length > 0 && this.setState({ hasActiveVkCabinets: true }));
      agencies
        .getCabinets(15)
        .then((resp) => resp.items.length > 0 && this.setState({ hasActiveVkCabinets: true }));
    });

    this.props.startSetStreamLandingFeaturesSettings().then(() => {
      // fill state with default iframe settings
      let iframeSettingsConfig = {};
      iframeSettingsConfig['iframe/20'] = true;

      this.props.streamLandingSettings?.iframe?.fields?.length &&
        this.recursivelyMapIFrameDefaults(
          'iframe/20',
          this.props.streamLandingSettings.iframe.fields,
          iframeSettingsConfig,
        );
      this.setState((prev) => ({
        currentIFrameSettings: iframeSettingsConfig,
        iframeConstructorLoading: false,
      }));
    });

    if (localStorage.getItem('showed_direct_link_tour')) {
      this.setState({
        alreadyShowedDirectLinkTour: true,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { offer } = this.props;
    const { stream = {} } = this.props;
    if (offer.id !== this.state.stream.offerId) {
      this.setState((prevState) => ({
        stream: {
          ...prevState.stream,
          offerId: offer.id,
        },
      }));
    }

    if (stream.id !== this.state.stream.id || stream.encId !== this.state.stream.encId) {
      if (stream.settings?.landings) {
        let mainSettingsConfig = {};
        let currentSettings = stream.settings.landings;
        for (let key in currentSettings) {
          let match = this.props.streamLandingSettings.main_settings_block?.find((s) =>
            s.fields.find((f) => f.id == key),
          );

          if (match) {
            mainSettingsConfig[`main_settings_block/${match.id}`] = true;
            if (currentSettings[key].e)
              mainSettingsConfig[`main_settings_block/${match.id}/${key}`] = true;

            this.recursivelyMapValues(
              ['main_settings_block', match.id, key],
              currentSettings[key].f,
              mainSettingsConfig,
            );
          }
        }

        this.setState({
          currentLandingSettings: mainSettingsConfig,
        });

        // iframe settings
        let iframeSettingsConfig = {};
        this.recursivelyMapValues(['iframe', '20'], currentSettings['20']?.f, iframeSettingsConfig);

        this.setState((prev) => ({
          currentIFrameSettings: { ...prev.currentIFrameSettings, ...iframeSettingsConfig },
        }));
      }

      this.setState(() => ({
        stream: {
          ...stream,
          direct_link_without_redirect: this.getDirectLinkSubdomain(
            stream.directLinkLandingWithoutRedirect,
          ),
          isTikTok: stream.settings?.landings && stream.settings.landings['34']?.e ? true : false,
        },
        isUsingDirectLinkWithoutRedirectLanding: !!stream.directLinkLandingWithoutRedirect,
        isPrelandersCollapseOpen: !!stream.transitsId.length,
      }));
    }

    if (
      this.state.stream.editable &&
      !this.state.showWarning &&
      this.props.offer !== prevProps.offer &&
      this.props.offer.modifies?.is_cdn &&
      !!parse(this.props.location.search).created
    ) {
      statistics
        .getStats('times', {
          dateFrom: moment().subtract(1, 'month').format('DD.MM.YYYY'),
          dateTo: moment().format('DD.MM.YYYY'),
        })
        .then((resp) => {
          const totalLeads =
            resp.total && resp.total[127] && resp.total[127].reduce((acc, val) => acc + val);
          if (totalLeads < 30) {
            this.setState({ showWarning: true });
          }
        })
        .catch(console.log);
    }

    if (
      !this.state.showDirectLinkTour &&
      !this.state.alreadyShowedDirectLinkTour &&
      this.props.offer?.modifies?.is_cdn
    ) {
      this.setState({
        showDirectLinkTour: true,
      });
    }
  }

  getFlowIndex = (nextProps) => {
    const { settings } = nextProps;
    const { settings: prevSettings } = this.props;
    if (settings && settings.base) {
      if (settings.base.nextFlowIndex !== undefined) {
        if (prevSettings && Object.keys(prevSettings) && Object.keys(prevSettings).length === 0) {
          return settings.base.nextFlowIndex;
        }
      }
    }
    return null;
  };

  componentWillUnmount() {
    this.props.resetStream();
  }

  /**
   * Convert object from received format ( {1: {e: "1", f: [...fields]}} )
   * to another with "path/to/value" as keys
   * @param {Array} parentPath - Path to add on to
   * @param {Object} obj - Object with values to map
   * @param {Object} resultToModify - Mutable result object
   */
  recursivelyMapValues = (parentPath, obj, resultToModify = {}) => {
    for (let key in obj) {
      if (typeof obj[key] === 'object') {
        if (obj[key].e) resultToModify[[...parentPath, key].join('/')] = true;
        if (obj[key].f) this.recursivelyMapValues([...parentPath, key], obj[key].f, resultToModify);
      } else {
        resultToModify[[...parentPath, key].join('/')] = obj[key];
      }
    }
  };

  /**
   * Map default iframe settings values to "path/to/value" keys
   * @param {string} parnetPath - Path to add on to
   * @param {Array} fieldsArr - Array with iframe constructor fields objects
   * @param {Object} resObj - Mutable result object
   */
  recursivelyMapIFrameDefaults = (parnetPath, fieldsArr, resObj) => {
    for (let field of fieldsArr) {
      const ownPath = `${parnetPath}/${field.id}`;
      if (ownPath.split('/').length !== 3 && !this.state.currentIFrameSettings[ownPath]) {
        if (field.type === 'range') {
          resObj[ownPath] = +field.default;
        } else {
          resObj[ownPath] = field.default;
        }
      }
      if (field.fields) {
        this.recursivelyMapIFrameDefaults(ownPath, field.fields, resObj);
      }
    }
  };

  /**
   * Sort landing by their id
   *
   * @param {Array} landings Array of landings
   * @return {Array} Array of sorted landing
   */
  sortLandingsByTotalCr = (landings = []) => landings.sort((a, b) => b.totalCr - a.totalCr);

  /**
   * Merge click link with params
   *
   * @param {string} link Click link
   * @param {string} [delimiter] Delimiter
   * @return {string} Merged link
   */
  getComputedLink = (link = '', delimiter = '/') => {
    const { subAccount } = this.state;
    const { deepLink } = this.state;

    if (subAccount || deepLink) {
      link += `${subAccount && delimiter + subAccount}${deepLink && delimiter + deepLink}`;
    }

    return link;
  };

  /**
   * Set stream's changes to state
   *
   * @param {*} event Event
   */
  handleChange = ({ target }) => {
    this.setState((prevState) => ({
      stream: {
        ...prevState.stream,
        [target.name]: target.value,
      },
    }));
  };

  /**
   * Set stream's agency
   * @param {*} selected Agency id
   */
  handleAgencyChange = (selected) => {
    if (selected?.value === 'vkcom' && !this.state.hasActiveVkCabinets) {
      return this.setState({ showVkCabinetSubtext: true });
    }

    const agency = selected === null ? selected : selected.value;
    this.setState((prevState) => ({
      stream: {
        ...prevState.stream,
        abTest: agency === null,
        landingsId: [prevState.stream.landingsId[0]] || [0],
        transitsId: [prevState.stream.transitsId[0]] || [],
        agency,
      },
      showVkCabinetSubtext: false,
    }));
  };

  /**
   * Set stream's offer
   *
   * @param {?Object} selected Object with offer id
   * @param {boolean} [silent] Affect stream
   */
  handleOfferChange = (selected, silent = false) => {
    if (selected !== null) {
      const { value: offerId } = selected;

      this.setState(
        (prevState) => {
          return silent
            ? { ...prevState.stream, offerId }
            : {
                stream: {
                  ...prevState.stream,
                  landingsId: [0],
                  transitsId: [],
                  offerId,
                  pixels: [],
                },
              };
        },
        () => {
          this.props.onOfferChange(offerId);
        },
      );
    }
  };

  /**
   * Set stream's selected landings
   *
   * @param {number} id Landing id
   */
  handleLandingChange = (id) => {
    const { stream, isUsingDirectLinkWithoutRedirectLanding, domainParking } = this.state;
    let landingsId;

    if (stream.abTest && !isUsingDirectLinkWithoutRedirectLanding && !domainParking.enabled) {
      if (stream.landingsId.includes(id)) {
        landingsId = stream.landingsId.filter((landId) => landId !== id);
      } else {
        landingsId = [...stream.landingsId, id];
      }
    } else {
      landingsId = [id];
    }

    this.setState((prevState) => ({
      stream: {
        ...prevState.stream,
        landingsId,
      },
    }));
  };

  //deeplink handler
  handleDeepLinkChande = (e) => {
    const {
      target: { value: deepLink },
    } = e;
    this.setState({
      deepLink,
    });
  };

  resetTransitFeatures = () => {
    const transitFeatures = {
      ...this.state.stream.transitFeatures,
    };

    Object.keys(transitFeatures).forEach((feature) => {
      transitFeatures[feature] = false;
    });

    this.setState((prevState) => ({
      stream: {
        ...prevState.stream,
        transit_comebacker: 0,
        transitFeatures,
      },
    }));
  };

  /**
   * Set stream's selected prelanders
   *
   * @param {number} id Prelander id
   * @param {?Object} e Click event
   */
  handleTransitChange = (id, e) => {
    const { stream } = this.state;
    let transitsId;

    if (id === 0) {
      e && e.preventDefault();

      this.setState((prevState) => ({
        stream: {
          ...prevState.stream,
          transitsId: [],
        },
      }));

      this.resetTransitFeatures();

      return;
    }

    if (stream.transitsId.includes(id)) {
      transitsId = stream.abTest ? stream.transitsId.filter((transitId) => transitId !== id) : [];
    } else {
      transitsId = stream.abTest ? [...stream.transitsId, id] : [id];
    }

    this.setState(
      (prevState) => ({
        stream: {
          ...prevState.stream,
          transitsId,
        },
      }),
      () => {
        if (!this.state.stream.transitsId.length) {
          this.resetTransitFeatures();
        }
      },
    );
  };

  /**
   * Set stream's postback settings
   *
   * @param {*} postback Postback settings
   */
  handlePostbackChange = (postback) => {
    this.setState((prevState) => ({
      stream: {
        ...prevState.stream,
        postback,
      },
    }));
  };

  /**
   * Set postback's pixels settings
   *
   * @param {*} pixels Selected pixels
   */
  handlePixelChange = (pixels) => {
    this.setState((prevState) => ({
      stream: {
        ...prevState.stream,
        pixels,
      },
    }));
  };

  /**
   * Set postback's statuses settings
   *
   * @param {*} statuses Selected statuses
   */
  handleStatusChange = (statuses) => {
    this.setState((prevState) => ({
      stream: {
        ...prevState.stream,
        statuses,
      },
    }));
  };

  /**
   * Set flows's trafficback URL
   *
   * @param {string} url Trafficback URL
   */
  handleTrafbackUrlChange = (url) => {
    this.setState((prevState) => ({
      stream: {
        ...prevState.stream,
        trafficback: url,
      },
    }));
  };

  /**
   * Set flows's fail action
   *
   * @param {*} action Fail action
   */
  handleFailActionChange = ({ type, value }) => {
    this.setState((prevState) => ({
      stream: {
        ...prevState.stream,
        failAction: { type, value },
      },
    }));
  };

  /**
   * Change flows's subaccount
   *
   * @param {string} subAccount Subaccount
   */
  handleSubAccountChange = (subAccount) => {
    this.setState(() => ({ subAccount }));
  };

  /**
   * Set flows's trackers settings
   *
   * @param {*} tracker Tracker settings
   */
  handleTrackerChange = (tracker = {}, page) => {
    this.setState((prevState) => ({
      stream: {
        ...prevState.stream,
        trackers: {
          ...prevState.stream.trackers,
          [page]: {
            ...prevState.stream.trackers[page],
            ...tracker,
          },
        },
      },
    }));
  };

  handleUseTransitsChange = () => {
    this.setState((prevState) => ({
      use_transit_service: !prevState.use_transit_service,
    }));
  };

  handleSetComebackerTransitsIds = (nextComebacker, prevStream) => {
    const { offer } = this.props;
    const prevIds = prevStream.transitsId;
    if (prevIds.length === 0) {
      if (nextComebacker) {
        const { transits } = offer;
        if (transits[0]) {
          return [transits[0].id];
        }
      }
    }
    return prevIds;
  };

  handleTransitsComebackerChange = () => {
    this.setState((prevState) => {
      const comebacker = !!prevState.stream.transit_comebacker ? 0 : 1;
      return {
        stream: {
          ...prevState.stream,
          transit_comebacker: comebacker,
          transitsId: this.handleSetComebackerTransitsIds(comebacker, prevState.stream),
        },
      };
    });
  };

  handleTransitFeatureChange = ({ target }) => {
    this.setState((prevState) => ({
      stream: {
        ...prevState.stream,
        transitFeatures: {
          ...prevState.stream.transitFeatures,
          [target.name]: target.checked,
        },
      },
    }));
  };

  handleNewsShowcaseSettingsChange = (e, field) => {
    this.setState((prevState) => ({
      stream: {
        ...prevState.stream,
        transitFeatures: {
          ...prevState.stream.transitFeatures,
          [field]: e ? e.value : e,
        },
      },
    }));
  };

  /**
   * Convert stream data to sending format
   *
   * @param {*} stream Stream data
   * @return {*} Converted data
   */
  prepareData = (stream) => {
    // get iframe constructor landing id
    const { landings } = this.props.offer;
    const iframeLandingId = landings.find((l) => l.url.includes('iframe_constructor'))?.id;

    let data = {
      agency: stream.agency,
      title: stream.title,
      offer_id: stream.offerId,
      'landings[]': stream.landingsId,
      'transits[]': stream.transitsId,
      postback: stream.postback.url,
      postback_method: stream.postback.method,
      'postback_pixels_status[]': stream.statuses,
      'postback_pixels[]': stream.pixels,
      activate_split_test: Number(stream.abTest),
      trafficback: stream.trafficback,
      'transit_settings[]': [],
      fail_type: this.state.stream.failAction?.type,
      fail_value: this.state.stream.failAction?.value,
      ...this.prepareTrackers(stream.trackers),
      // main features
      ...this.prepareFeatures(this.state.currentLandingSettings, 2),
      transit_comebacker: stream.transit_comebacker,
      ...this.prepareTransitFeatures(stream.transitFeatures),
      direct_link_without_redirect: this.state.isUsingDirectLinkWithoutRedirectLanding
        ? stream.direct_link_without_redirect
        : null,
    };

    // iframe settings only if iframe landing selected
    if (stream.landingsId.includes(iframeLandingId)) {
      data = { ...data, ...this.prepareFeatures(this.state.currentIFrameSettings, 1) };
    }

    if (this.state.stream.isTikTok) {
      data['landing_settings[34]'] = JSON.stringify({ e: 1 });
    }

    if (stream.rotator_domain) {
      data.rotator_domain = stream.rotator_domain;
    }
    return data;
  };

  prepareTrackers = () => {
    const { trackers } = this.state.stream;
    const trackersByPages = Object.keys(trackers).reduce((prepared, tracker) => {
      return {
        ...prepared,
        [`trackers_${tracker}`]: { ...trackers[tracker] },
      };
    }, {});
    const preparedTrackersByKeys = {};
    Object.keys(trackersByPages).forEach((pageKey) => {
      if (trackersByPages[pageKey]) {
        Object.keys(trackersByPages[pageKey]).forEach((trackerKey) => {
          preparedTrackersByKeys[trackerKey] = trackersByPages[pageKey][trackerKey];
        });
      }
    });
    Object.keys(preparedTrackersByKeys).forEach((key) => {
      const match = /^tracking_13_pixel_id_(\d+)$/.exec(key);
      if (match && preparedTrackersByKeys[key]) {
        preparedTrackersByKeys[`tracking_13_event_${match[1]}`] = 'purchase';
      }
    });
    return preparedTrackersByKeys;
  };

  /**
   * Convert landing's features for sending format
   *
   * @param {Array} settings - Landing's settings
   * @param {number} servicePrefixLength - Number of elements to remome from path's beginning (path divided by "/")
   * @returns {Object} Converted data object
   */
  prepareFeatures = (settings, servicePrefixLength) => {
    const result = Object.keys(settings).reduce((acc, key) => {
      // remove top level groups from path
      let path = key.split('/').slice(servicePrefixLength);
      // return if top level group
      if (!path.length) return acc;
      // insert f key for each feature with children
      if (path.length > 1) {
        for (let i = 1; i < path.length; i += 2) {
          if (i % 2 !== 0) {
            path.splice(i, 0, 'f');
          }
        }
      }
      // convert boolean value
      let value = settings[key];
      if (typeof value === 'boolean') value = { e: value ? 1 : 0 };
      //
      setDeep(acc, path, value, true);

      return acc;
    }, {});

    return Object.keys(result).reduce((acc, key) => {
      acc[`landing_settings[${key}]`] = JSON.stringify(result[key]);
      return acc;
    }, {});
  };

  prepareTransitFeatures = (features = {}) => {
    const result = {};

    for (let i in features) {
      if (features[i]) {
        result[`transit_settings[${i}]`] = features[i];
      }
    }

    return result;
  };

  /**
   * Sending stream's data
   *
   * @param {*} e Form native event
   */
  handleSubmit = (e) => {
    e.preventDefault();

    const { stream, use_transit_service, domainParking } = this.state;

    this.validate(stream).then((errors) => {
      this.setState(
        () => ({ errors }),
        () => {
          const types = Object.keys(errors);
          if (types.length > 0) {
            const key = types[0];

            if (this._alertRefs[key] && this._alertRefs[key].current) {
              animatedScrollTo(this._alertRefs[key].current, 400, 80);
            }
          }
        },
      );

      if (Object.keys(errors).length === 0) {
        if (this.props.profile) {
          if (this.props.profile.use_transit_service !== use_transit_service) {
            const profile = cloneDeep(this.props.profile);
            profile['use_transit_service'] = use_transit_service;
            this.props.startSetEditProfile(profile).then(() => this.props.startSetProfile());
          }
        }

        if (
          domainParking.enabled &&
          domainParking.domainName &&
          !this.props.offer.categories.includes(40)
        ) {
          if (!isURL(domainParking.domainName))
            return this.props.showAlert({
              dismissable: true,
              alertType: 'danger',
              message: this.props.intl.formatMessage({
                id: 'flow.form.park-domian.error.invalid-domain',
                defaultMessage: 'Check your domain name',
              }),
              closeInSeconds: 5,
            });

          // припарковать домен перед созданием потока
          return domains
            .create(
              {
                domain: domainParking.domainName,
                landingId: this.state.stream.landingsId[0],
                offerId: this.state.stream.offerId,
              },
              'landing',
            )
            .then((resp) => {
              const id = resp.items[0]?.id;
              this.setState(
                (prev) => ({
                  stream: {
                    ...prev.stream,
                    landingsId: [`l${id}`],
                  },
                }),
                () => {
                  if (stream.id) {
                    this.props.onSubmit(stream.id, this.prepareData(this.state.stream));
                  } else {
                    this.props.onSubmit(this.prepareData(this.state.stream));
                  }
                },
              );
            })
            .catch((err) => {
              const error =
                err.response.data?.error?.message?.message ??
                this.props.intl.formatMessage({
                  id: 'main.error',
                  defaultMessage: 'Error',
                });
              this.props.showAlert({
                dismissable: true,
                alertType: 'danger',
                message: error,
                closeInSeconds: 5,
              });
            });
        }

        if (stream.id) {
          this.props.onSubmit(stream.id, this.prepareData(stream));
        } else {
          this.props.onSubmit(this.prepareData(stream));
        }
      }
    });
  };

  /**
   * Validate stream's data
   *
   * @param {*} stream Stream data
   * @return {*} Validation errors
   */
  validate = (stream) => {
    const errors = {};
    const { isClick, isUsingDirectLinkWithoutRedirectLanding } = this.state;
    const { showAlert, intl } = this.props;

    if (isClick) {
      if (!stream.rotator_domain || !isURL(stream.rotator_domain)) {
        errors.rotator_domain = <FMessage id="flow.errors.no-domain-title" />;
      }
    }

    if (!stream.title) {
      errors.title = <FMessage id="flow.errors.no-title" />;
    }

    if (!stream.offerId) {
      errors.offer = <FMessage id="flow.errors.no-offer" />;
    }

    if (isUsingDirectLinkWithoutRedirectLanding) {
      if (!stream.direct_link_without_redirect) {
        errors.directLinkLanding = (
          <FormattedMessage
            id="flow.errors.no-direct-link-landing"
            defaultMessage="Please select the flow"
          />
        );
      }

      // Асинхронная проверка домена прямой ссылки, если он используется
      return this.checkDirectLinkWithoutRedirect()
        .then(() => Promise.resolve(errors))
        .catch((err) => {
          errors.directLinkLanding = err;
          return Promise.resolve(errors);
        });
    }

    return Promise.resolve(errors);
  };

  handleDomainCheck = () => {
    const { rotator_domain } = this.state.stream;
    const { type } = this.state;

    domains.checkDomain(rotator_domain, type).then(({ status }) => {
      const message = status ? (
        <FormattedMessage id="domain.form.name.check.success" defaultMessage="CNAME found" />
      ) : (
        <FormattedMessage id="domain.form.name.check.error" defaultMessage="CNAME not found" />
      );
      this.toggleModal(null, message);
    });
  };

  toggleModal = (e, message = '') => {
    this.setState((prevState) => ({ modal: !prevState.modal, message }));
  };

  handleDomainChange = (rotator_domain = '') => {
    this.setState((prevState) => ({
      stream: {
        ...prevState.stream,
        rotator_domain,
      },
    }));
  };

  getParkingType = () => {
    const { type } = this.state;
    const { types } = this.props;
    return types.find((pType) => pType.key === type);
  };

  setTopLink = () => {
    const {
      offer: { top_bundle },
    } = this.props;
    this.setState((prevState) => {
      return {
        stream: {
          ...prevState.stream,
          landingsId: [top_bundle.landing],
          transitsId:
            prevState.isUsingDirectLinkWithoutRedirectLanding || prevState.domainParking.enabled
              ? []
              : [top_bundle.prelanding],
        },
      };
    });
  };

  toggleIframeConstructorModal = () => {
    this.setState((prevState) => ({
      iframeConstructorModalOpen: !prevState.iframeConstructorModalOpen,
    }));
  };

  getOffersWithNoReplics = () => {
    const { offers, replicaOffersIds } = this.props;
    const { type } = this.state;

    if (type === 'click') {
      const filteredOffers = offers.filter((offer) => !replicaOffersIds.includes(offer.id));
      return filteredOffers;
    }
    return offers;
  };

  toggleTrackersDropdown = () => {
    this.setState((prevState) => ({
      ...prevState,
      trackersDropdownOpen: !prevState.trackersDropdownOpen,
    }));
  };

  toggleExtraSettings = () => {
    this.setState((prevState) => ({
      ...prevState,
      isExtraSettingsOpen: !prevState.isExtraSettingsOpen,
    }));
  };

  excludeDomainsFromABTest = (items) => items.filter((item) => typeof item !== 'string');

  checkABTestEnabled = () => {
    const { stream } = this.state;
    const { landingsId, transitsId, abTest } = stream;
    return {
      landingsABTestEnabled: abTest && this.excludeDomainsFromABTest(landingsId).length >= 2,
      transitsABTestEnabled: abTest && this.excludeDomainsFromABTest(transitsId).length >= 2,
    };
  };

  /**
   * @param {string} url
   * @return {string} subdomain
   */
  getDirectLinkSubdomain = (url) => {
    if (!url) {
      return '';
    }

    return url.replace(/https?:\/\//, '').split('.')[0];
  };

  toggleDirectLinkWithoutRedirectLandingUsage = (e) => {
    this.setState(
      (prevState) =>
        prevState.isUsingDirectLinkWithoutRedirectLanding
          ? {
              isUsingDirectLinkWithoutRedirectLanding: false,
            }
          : {
              isUsingDirectLinkWithoutRedirectLanding: true,
              domainParking: {
                ...prevState.domainParking,
                enabled: false,
              },
            },
      () => {
        const { isUsingDirectLinkWithoutRedirectLanding } = this.state;
        if (isUsingDirectLinkWithoutRedirectLanding) {
          this.disableOptionsForDirectLinkUsage();
        }
      },
    );
  };

  handleDirectLinkSubdomainChange = (direct_link_without_redirect) => {
    this.setState((prevState) => {
      let errors = prevState.errors;
      if (prevState.errors.directLinkLanding) {
        errors = {
          ...errors,
          directLinkLanding: null,
        };
      }
      return {
        stream: {
          ...prevState.stream,
          direct_link_without_redirect,
        },
        errors,
      };
    });
  };

  togglePrelandersCollapse = () => {
    this.setState((prevState) => ({
      isPrelandersCollapseOpen: !prevState.isPrelandersCollapseOpen,
    }));
  };
  moveIframeConstructorToEnd = (arr = []) => {
    arr.forEach((landing, index) => {
      if (landing.url.includes('iframe_constructor')) {
        arr.push(arr.splice(index, 1)[0]);
      }
    });
    return arr;
  };

  checkDirectLinkWithoutRedirect = () => {
    return new Promise((resolve, reject) => {
      const {
        stream: { id: flowId, direct_link_without_redirect: domain },
      } = this.state;
      streams
        .checkDirectLinkWithoutRedirectAvailability({ domain, flowId })
        .then((response) => {
          const { errors } = this.state;
          resolve(response);
        })
        .catch((err) => {
          const message = err?.response?.data?.error?.message?.message || err.toString();
          this.setState(
            (prevState) => ({
              errors: {
                ...prevState.errors,
                directLinkLanding: message,
              },
            }),
            () => {
              animatedScrollTo(this._alertRefs['directLinkLanding'].current, 400, 80);
              reject(message);
            },
          );
        });
    });
  };

  handleClickVkWarningLink = () => {
    this.props.setRedirectToAgenciesData(2);
  };

  domainParkingToggle = () => {
    this.setState(
      (prev) =>
        prev.domainParking.enabled
          ? {
              domainParking: {
                ...prev.domainParking,
                enabled: false,
              },
            }
          : {
              domainParking: {
                ...prev.domainParking,
                enabled: true,
              },
              isUsingDirectLinkWithoutRedirectLanding: false,
            },
      () => {
        const { domainParking } = this.state;
        if (domainParking.enabled) {
          this.disableOptionsForDirectLinkUsage();
        }
      },
    );
  };

  handleDomainParkingChange = (domainName) => {
    this.setState((prev) => ({
      domainParking: {
        ...prev.domainParking,
        domainName,
      },
    }));
  };

  handleDirectLinkTourClose = () => {
    localStorage.setItem('showed_direct_link_tour', true);
    this.setState({
      alreadyShowedDirectLinkTour: true,
      showDirectLinkTour: false,
    });
  };

  disableOptionsForDirectLinkUsage = () => {
    const {
      stream: { landingsId, trafficback, failAction, agency, transitsId },
    } = this.state;
    // сбрасываем все, что не может работать с прямой ссылкой
    // транзитки
    if (transitsId.length) {
      this.handleTransitChange(0, null);
    }

    // аб тест лендов
    if (landingsId.length > 1) {
      this.handleLandingChange(0);
    }

    // trafficback
    if (failAction.type || trafficback) {
      this.setState((prevState) => ({
        stream: {
          ...prevState.stream,
          failAction: { type: '', value: null },
          trafficback: '',
        },
      }));
    }

    // агентские кабинеты
    if (agency) {
      this.handleAgencyChange(null);
    }
  };

  /**
   * Updates single state value
   * @param {function} mutatorFunction - Function that accepts mutable state draft and returns new state chunk
   * @param {string} key - Key for state chunk to change
   */
  handleCurrentStateChunkChange = (mutatorFunction, key) => {
    this.setState((prev) => ({
      [key]: mutatorFunction({ ...prev[key] }),
    }));
  };

  handleCurrentLandingSettingsChange = (mutatorFunction) => {
    this.handleCurrentStateChunkChange(mutatorFunction, 'currentLandingSettings');
  };

  handleCurrentLandingSettingsOverridesChange = (mutatorFunction) => {
    this.handleCurrentStateChunkChange(mutatorFunction, 'currentLandingSettingsOverrides');
  };

  handleIsTikTokChange = () => {
    this.setState((prev) => ({
      stream: { ...prev.stream, isTikTok: !prev.stream.isTikTok },
    }));
  };

  handleIFrameConstructorSave = (newSettings) => {
    this.setState({
      currentIFrameSettings: newSettings,
      iframeConstructorModalOpen: false,
    });
  };

  render() {
    const { stream, redirectedFromOffer, showVkCabinetSubtext, showWarning } = this.state;
    const { offer, profile, replicaOffersIds } = this.props;
    const isEdit = !!stream.id;
    const isCdn = offer.modifies ? offer.modifies.is_cdn : false;
    const isUserBlocked = profile && profile.banned;
    const { site_key } = profile;

    const { landingsABTestEnabled, transitsABTestEnabled } = this.checkABTestEnabled();

    const data = {
      ...this.props,
      ...this.state,
      landingsABTestEnabled,
      transitsABTestEnabled,
      isEdit,
      isCdn,
      isUserBlocked,
      site_key,
    };

    const topBundle = offer.top_bundle ? offer.top_bundle : {};

    return (
      <FlowFormView
        redirectedFromOffer={redirectedFromOffer}
        data={data}
        topBundle={topBundle}
        handleSubmit={this.handleSubmit}
        getComputedLink={this.getComputedLink}
        handleSubAccountChange={this.handleSubAccountChange}
        _alertRefs={this._alertRefs}
        handleDomainCheck={this.handleDomainCheck}
        handleDomainChange={this.handleDomainChange}
        getParkingType={this.getParkingType}
        getOffersWithNoReplics={this.getOffersWithNoReplics}
        handleOfferChange={this.handleOfferChange}
        handleAgencyChange={this.handleAgencyChange}
        sortLandingsByTotalCr={this.sortLandingsByTotalCr}
        handleLandingChange={this.handleLandingChange}
        toggleIframeConstructorModal={this.toggleIframeConstructorModal}
        handleTransitsComebackerChange={this.handleTransitsComebackerChange}
        handleTransitFeatureChange={this.handleTransitFeatureChange}
        handleNewsShowcaseSettingsChange={this.handleNewsShowcaseSettingsChange}
        handleUseTransitsChange={this.handleUseTransitsChange}
        handleTransitChange={this.handleTransitChange}
        toggleExtraSettings={this.toggleExtraSettings}
        handlePostbackChange={this.handlePostbackChange}
        handleStatusChange={this.handleStatusChange}
        handlePixelChange={this.handlePixelChange}
        handleTrafbackUrlChange={this.handleTrafbackUrlChange}
        handleFailActionChange={this.handleFailActionChange}
        handleTrackerChange={this.handleTrackerChange}
        toggleTrackersDropdown={this.toggleTrackersDropdown}
        toggleModal={this.toggleModal}
        handleChange={this.handleChange}
        setTopLink={this.setTopLink}
        handleDeepLinkChande={this.handleDeepLinkChande}
        togglePrelandersCollapse={this.togglePrelandersCollapse}
        moveIframeConstructorToEnd={this.moveIframeConstructorToEnd}
        handleDirectLinkSubdomainChange={this.handleDirectLinkSubdomainChange}
        toggleDirectLinkWithoutRedirectLandingUsage={
          this.toggleDirectLinkWithoutRedirectLandingUsage
        }
        checkDirectLinkWithoutRedirect={this.checkDirectLinkWithoutRedirect}
        showVkCabinetSubtext={showVkCabinetSubtext}
        handleClickVkWarningLink={this.handleClickVkWarningLink}
        showWarning={showWarning}
        replicaOffersIds={replicaOffersIds}
        domainParkingToggle={this.domainParkingToggle}
        onDomianParkingInputChange={this.handleDomainParkingChange}
        handleDirectLinkTourClose={this.handleDirectLinkTourClose}
        iframeConstructorLoading={this.state.iframeConstructorLoading}
        handleIsTikTokChange={this.handleIsTikTokChange}
        handleCurrentLandingSettingsChange={this.handleCurrentLandingSettingsChange}
        handleCurrentLandingSettingsOverridesChange={
          this.handleCurrentLandingSettingsOverridesChange
        }
        handleIFrameConstructorSave={this.handleIFrameConstructorSave}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  settings: state.streams.settings,
  offers: state.webmaster.offers,
  types: state.app.globalSettings.parking,
  profile: state.webmaster.profile,
  replicaOffersIds: state.domains.replicaOffersIds,
  streamLandingSettings: state.streams.streamLandingSettings,
});

const mapDispatchToProps = (dispatch) => ({
  startSetStreamOffer: (id) => dispatch(startSetStreamOffer(id)),
  startSetMyOffers: (params) => dispatch(startSetMyOffers(params)),
  resetStream: () => dispatch(resetStream()),
  startSetStreamSettings: () => dispatch(startSetStreamSettings()),
  startSetEditProfile: (data) => dispatch(startSetEditProfile(data)),
  startSetProfile: (params) => dispatch(startSetProfile(params)),
  setRedirectToAgenciesData: (agencyId) => dispatch(setRedirectToAgenciesData(agencyId)),
  startSetDomainReplicaOffersIds: () => dispatch(startSetDomainReplicaOffersIds()),
  startSetStreamLandingFeaturesSettings: () => dispatch(startSetStreamLandingFeaturesSettings()),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(FlowForm)));
